import { PersonsInvoiceElementsService } from '@festina/moneyin-general-types/moneyin/services/PersonsInvoiceElementsService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  PersonsInvoiceElementsService.personInvoiceElementsServicePostCreateInvoice

export const useSubmitCreatePersonInvoiceElementsInvoice = (
  tenantId: string,
  personId: string,
) =>
  useFestinaMutation({
    component: 'moneyIn',
    isScenario: false,
    mutateFunction: async (_: Record<string, unknown>) => {
      await method({
        xTenantId: tenantId,
        personId,
      })
    },
    roles:
      PersonsInvoiceElementsService.personInvoiceElementsServicePostCreateInvoice_roles,
  })
